<template>
    <b-card header="Enrollment Queue"
            header-bg-variant="info"
            header-text-variant="white"
    >
        <div class="row with-padding-bottom">

            <div class="col-md-12 my-1">

                <b-btn variant="success" @click="sendCsv()" size="lg">Submit to DRC</b-btn>
            </div>
            <div class="col-md-3 my-1">

                <b-select v-model="statusFilter">

                    <option value="">--Filter Queue--</option>
                    <option value="not_sent">Not Sent</option>
                    <option value="sent">Sent Letters</option>
                </b-select>
            </div>
            <div class="col-md-3 my-1">

                <b-form-select v-model="specialistFilter">

                    <option value="">--Filter Specialist--</option>
                    <option v-for="admin in admins" :key="admin.id" :value="admin.id">{{ admin.nameLastFirst }}</option>
                </b-form-select>
            </div>
            <div class="col-md-3 my-1">

                <carrier-parents-dropdown v-model=" parent_carrier "></carrier-parents-dropdown>
            </div>
            <div class="col-md-3 my-1">

                <carrier-dropdown v-model=" carrier "></carrier-dropdown>
            </div>
        </div>
        <div class="table-responsive">
            <b-row>
                <b-col class="text-right mb-3">
                    <b-btn variant="success" :href="url + '&export=1'" :disabled="loading">
                        <i class="fa fa-file-excel-o"></i> Export to Excel
                    </b-btn>
                    <b-btn variant="info" @click="fetch()" :disabled="loading">Generate</b-btn>
                </b-col>
            </b-row>

            <loading-card v-show="loading"></loading-card>

            <b-table bordered striped hover show-empty
                     :items="items"
                     :fields="fields"
                     :current-page="currentPage"
                     :per-page="perPage"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     v-show="!loading"
            >
                <template v-slot:cell(checkbox)="row">
                    <div class="form-check">
                        <b-form-checkbox :value="row.item.id"></b-form-checkbox>
                    </div>
                </template>
                <template v-slot:cell(actions)="row">
                    <b-btn size="sm" :href="profileUrl(row.item)" title="View Profile">
                        <i class="fa fa-user"></i>
                    </b-btn>
                    <b-btn size="sm" @click="deleteItem(row.item)" v-if="!row.item.sent_at" variant="danger">
                        <i class="fa fa-times"></i>
                    </b-btn>
                </template>
            </b-table>
        </div>

        <b-row>
            <b-col lg="6" >
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
            </b-col>
            <b-col lg="6" class="text-right">
                Showing {{ perPage < totalRows ? perPage : totalRows }} of {{ totalRows }} results
            </b-col>
        </b-row>
    </b-card>
</template>

<script>

    import FormatsDates from "../../mixins/FormatsDates";
    import HasCarrierDropdowns from '../../mixins/HasCarrierDropdowns';

    export default {

        name: "BusinessEnrollmentQueue",

        mixins: [ FormatsDates, HasCarrierDropdowns ],

        data() {

            return {

                active: 'active',
                totalRows: 0,
                perPage: 25,
                currentPage: 1,
                sortBy: 'created_at',
                sortDesc: true,
                loading: false,
                items: [],
                admins: [],
                statusFilter: "not_sent",
                specialistFilter: '',
                fields: [
                    {
                        key: 'user_name',
                        sortable: true,
                    },
                    {
                        key: 'user_type',
                        sortable: true,
                    },
                    {
                        key: 'carrier',
                        sortable: true,
                        formatter: x => x ? x : '-',
                    },
                    {
                        key: 'enrollment_type',
                        sortable: true,
                    },
                    {
                        key: 'created_at',
                        label: 'Date Added',
                        sortable: true,
                        formatter: (val) => this.formatDateFromUTC(val),
                    },
                    {
                        key: 'sent_at',
                        label: 'Date Sent',
                        sortable: true,
                        formatter: (val) => val ? this.formatDateFromUTC(val) : 'Not Sent',
                    },
                    {
                        key: 'error',
                        sortable: true,
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print'
                    }
                ]
            }
        },

        mounted() {

            this.fetchAdmins();
        },

        computed: {

            url() {

                return `/business/reports/enrollment-queue?json=1&status=${this.statusFilter}&specialist_id=${this.specialistFilter}&carrier=${this.carrier_query_string}`;
            },
        },

        methods: {

            async fetch() {
                this.loading = true;
                const response = await axios.get(this.url);
                this.items = response.data;
                this.totalRows = this.items.length;
                this.loading = false;
            },

            async deleteItem(item) {
                if (confirm('Are you sure you wish to remove this enrollment queue item?')) {
                    let form = new Form({});
                    await form.submit('delete', `/business/enrollment-queue/${item.id}`);
                    this.items = this.items.filter(n => n.id != item.id);
                }
            },

            async sendCsv() {
                if (confirm('Are you sure you wish to submit the unsent enrollees to DRC?')) {
                    let form = new Form({});
                    await form.post('/business/enrollment-queue/submit');
                }
            },

            fetchAdmins() {
                axios.get('/business/specialists')
                    .then( ({ data }) => {
                        this.admins = data;
                    })
                    .catch(e => {
                        this.admins = [];
                    })
            },

            profileUrl(user) {
                if (user.user_type === "Provider") {
                    return '/business/caregivers/' + user.user_id;
                }
                return '/business/clients/' + user.user_id;
            }
        },

        watch: {
            statusFilter() {
                this.fetch();
            },

            specialistFilter() {
                this.fetch();
            },

            carrier() {
                this.fetch();
            },

            parent_carrier() {
                this.fetch();
            },
        },
    }
</script>
